import React, { useEffect, useState } from 'react';

const RevealTransition = ({ children, className = '' }) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const id = requestAnimationFrame(() => setVisible(true));
    return () => cancelAnimationFrame(id);
  }, []);

  return (
    <div
      className={`transition-all duration-300 ease-out origin-top ${
        visible ? 'opacity-100 scale-100 translate-y-0' : 'opacity-0 scale-95 -translate-y-1'
      } ${className}`}
    >
      {children}
    </div>
  );
};

export default RevealTransition;
